import React, { useEffect, useRef } from 'react';
// import { useParams } from 'react-router-dom';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import styleClasses from '../css/mobile/LeftMenu.module.scss';

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

const LeftMenu = ({ musician, isGroup, setModalOpen, setArchiveModal, setPositionModal, setActivityModal, setContactModal, setMembersModal }) => {
  // const { id: musicianId } = useParams(); // URL에서 musicianId 가져오기
  
  const menuData = [
    { title: 'Music Archive', path: 'music-archive' },
    { title: isGroup ? 'Members' : 'Position & Skill', path: isGroup ? 'members' : 'position-skill' }, // ✅ 조건 추가
    { title: 'Activity', path: 'activity' },
    { title: 'Contact', path: 'contact' },
  ];
  
  const imgRefs = useRef([]);
  const leftRef = useRef(null);
  
  useEffect(() => {
    if (leftRef.current) {
      gsap.fromTo(
        leftRef.current, // current 사용
        { gridGap: 0 },
        {
          gridGap: '24px',
          scrollTrigger: {
            trigger: leftRef.current,
            start: 'top 80%',
            end: 'top top',
            scrub: 1,
            // markers: true
          },
        }
      );
      }

    imgRefs.current.forEach((el, index) => {
      if (el) {
        gsap.fromTo(
          el,
          { backgroundSize: '150%' },
          {
            backgroundSize: '100%',
            borderRadius: '8px',
            width: 'calc(100% - 48px)',
            minHeight: '96px',
            duration: 2,
            scrollTrigger: {
              trigger: el,
              start: 'top bottom',
              end: 'top 80%',
              scrub: 1,
              // markers: true
            },
          }
        );
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <div className={ styleClasses.leftMenuMobile } ref={ leftRef }>
      {     menuData.map((menu, index) => (
      <div
        key={index}
        // to={`/musicard/${musicianId}/${menu.path}`} // 뮤지션 ID 포함
        className={ styleClasses.menuItem }
        ref={(el) => (imgRefs.current[index] = el)}
          style={{
            backgroundImage: `
              linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), 
              url("${musician.menuImages[index] || '/assets/images/Background Test 1.png'}")
            `,
          }}
        onClick={() => {
          if (menu.path === 'music-archive') {
            setArchiveModal(true); setPositionModal(false); setActivityModal(false); setContactModal(false); setModalOpen(true);
          } else if (menu.path === 'position-skill') {
            setArchiveModal(false); setPositionModal(true); setActivityModal(false); setContactModal(false); setModalOpen(true);
          } else if (menu.path === 'members') {  // ✅ Members 팝업 추가
            setArchiveModal(false); setPositionModal(false); setActivityModal(false); setContactModal(false); setMembersModal(true); setModalOpen(true);
          } else if (menu.path === 'activity') {
            setArchiveModal(false); setPositionModal(false); setActivityModal(true); setContactModal(false); setModalOpen(true);
          } else if (menu.path === 'contact') {
            setArchiveModal(false); setPositionModal(false); setActivityModal(false); setContactModal(true); setModalOpen(true);
          }
        }}
        >
        {/* <div
          className="menu-background"
          
        ></div> */}
        <span className={ styleClasses.menuTitle } style={{ filter: 'none' }}>{menu.title}</span>
      </div>
    )) }
    </div>
  );
};

export default LeftMenu;
